import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service'
import {FundadminComponent} from './components/fundadmin.component'

const routes = [{
              path:'fundadmin',
              component:FundadminComponent,
              canActivate:[CanActivateViaAuthGuard]}]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FundadminRoutingModule { }
